// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Pagination-styles___paginationContainer--viCM6 {
  display: flex;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e0e2e6;
  border-radius: 4px;
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
  max-width: -moz-fit-content;
  max-width: fit-content;
  align-items: center;
  margin: auto;
}

.components-Pagination-styles___buttonPaginationPrev--PND11 {
  border-right: 1px solid #e0e2e6;
  height: 32px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.components-Pagination-styles___buttonPaginationPrev--PND11 svg {
  transform: rotate(-180deg);
}

.components-Pagination-styles___buttonPagination--feQmY {
  height: 32px;
  width: 25px;
  border-left: 1px solid #e0e2e6;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.components-Pagination-styles___numberHolder--WGqsP {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 32px;
}

.components-Pagination-styles___paginationPageCont--pACd8 {
  width: 100%;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./components/Pagination/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAAsB;EAAtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".paginationContainer {\n  display: flex;\n  height: 32px;\n  background: #ffffff;\n  border: 1px solid #e0e2e6;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n  max-width: fit-content;\n  align-items: center;\n  margin: auto;\n}\n\n.buttonPaginationPrev {\n  border-right: 1px solid #e0e2e6;\n  height: 32px;\n  width: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.buttonPaginationPrev svg {\n  transform: rotate(-180deg);\n}\n\n.buttonPagination {\n  height: 32px;\n  width: 25px;\n  border-left: 1px solid #e0e2e6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.numberHolder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 64px;\n  height: 32px;\n}\n\n.paginationPageCont {\n  width: 100%;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationContainer": `components-Pagination-styles___paginationContainer--viCM6`,
	"buttonPaginationPrev": `components-Pagination-styles___buttonPaginationPrev--PND11`,
	"buttonPagination": `components-Pagination-styles___buttonPagination--feQmY`,
	"numberHolder": `components-Pagination-styles___numberHolder--WGqsP`,
	"paginationPageCont": `components-Pagination-styles___paginationPageCont--pACd8`
};
module.exports = ___CSS_LOADER_EXPORT___;
